<template>
	<div class="content-box">
		<div class="operator">
			<div class="operator-col">
				<storehouse-input v-model="filterStorehouse"></storehouse-input>
			</div>
			<div class="operator-col" v-if="type == [20]">
				<warehouse-input v-model="filterWarehouse"></warehouse-input>
			</div>
			<div class="operator-col">
				<hispickup v-model="filterHisDate"></hispickup>
			</div>
			<div class="operator-col">
				<el-input
					size="mini"
					v-model="filterTableSearch"
					placeholder="商品名"
					suffix-icon="el-icon-search"
				></el-input>
			</div>
		</div>
		<curd-table
			ref="listTable"
			:data-model="listDataModel"
			:fields="tableFields"
			@doedit="handleEdit($event)"
			:date-filter="filterHisDate"
			:search-filter="filterTableSearch"
			:has-delete="false"
			:kv-filter="kvFilter"
		>
			<template slot="listOp" slot-scope="scope">
				<el-button size="mini" type="text" @click="goReserveTxInfo(scope.row._id)">详情</el-button>
			</template>
		</curd-table>
	</div>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterStorehouse from "@/mixins/Filter/FilterStorehouse.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";
import { mapState } from "vuex";

import TxOp from "@/mixinsApp/TxOp.js";
import WarehouseInput from "@/widgets/Inputs/WarehouseInput.vue";
import StorehouseInput from "@/widgets/Inputs/StorehouseInput.vue";

const TX_TYPE_OUTBOUND = 20;
const TX_TYPE_INBOUND = 21;

export default {
  components: {WarehouseInput},
  mixins: [CurdPage, Filters, FilterStorehouse, FilterWarehouse, TxOp],
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				filterStorehouse: { field: "storehouse", value: null },
				filterWarehouse: { field: "warehouse", value: null },
			},
			filterHisDate: [],
			filterTableSearch: "",
			listDataModel: "Reserve_transaction",
			editorId: "",
			tableFields: [
				{
					name: "show_id",
					isTrans: false,
					sortable: "custom",
				},
				{
					name: "name",
					isTrans: false,
					sortable: false,
					width: "400px",
				},
				{
					name: "storehouse",
					isTrans: true,
					sortable: "custom",
					isTag: true,
				},
				{
					name: "warehouse",
					isTrans: true,
					sortable: "custom",
					isTag: true,
				},
				{
					name: "created_user",
					isTrans: false,
					sortable: "custom",
				},

				{
					name: "created_at",
					isTrans: false,
					sortable: "custom",
				},
			],
		};
	},
	props: {
		type: {
			type: Array,
			default: function() {
				return [];
			},
		},
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),
	},
	watch: {
		type: {
			handler() {
				this.baseKv = [{ k: "type", v: this.type, t: "int", lge: "in" }];
			},
			immediate: true,
		},
		"filterStorehouse": {
			handler() {
				let val = this.filterStorehouse;
				if (val._id != null && val._id !== "") {
					this.$set(this.kvFilter, "storehouse", { k: "storehouse", t: "string", v: val._id });
				} else {
					this.$delete(this.kvFilter, "storehouse");
				}
			},
			immediate: true,
			deep: true,
		},

		"filterWarehouse": {
			handler() {
				let val = this.filterWarehouse;
				if (val._id != null && val._id !== "") {
					this.$set(this.kvFilter, "warehouse", { k: "warehouse", t: "string", v: val._id });
				} else {
					this.$delete(this.kvFilter, "warehouse");
				}
			},
			immediate: true,
			deep: true,
		},
	},
	created() {
		// this.replaceTableFields();
	},
	mounted() {},
	methods: {
		goReserveTxInfo(id) {
			// debugger;
			const { href } = this.$router.resolve({
				name: "Reserve-Tx-Info",
				params: {
					id: id,
					tab: "info",
				},
			});
			window.open(href, "_self");
		},

		replaceTableFields() {
			let index = -1;
			for (let k in this.tableFields) {
				if (
					typeof this.tableFields[k] == "string" &&
					this.tableFields[k] == "__targetByType__"
				) {
					index = k;
				}
			}
			if (index == -1) {
				return;
			}
			this.tableFields.splice(index, 1);
			for (let k in this.type) {
				if (this.type[k] == TX_TYPE_OUTBOUND) {
					this.tableFields.splice(index, 0, {
						name: "customer",
						sortable: "custom",
						width: "90px",
					});
					this.tableFields.splice(index, 0, {
						name: "express_type",
						render: info => {
							return "[" + info.express_type.name + "] " + info.address.name;
						},
					});
					this.tableFields.splice(index, 0, {
						name: "order",
						params: {
							link: "Order-Info",
						},
						sortable: false,
					});
					this.tableFields.splice(index, 0, {
						name: "express",
						sortable: false,
					});
					this.tableFields.splice(index, 0, {
						name: "tracking_number",
						sortable: false,
					});
				}
			}
			if (this.userPrivilegeMapping[59]) {
				this.tableFields.splice(index, 0, {
					name: "total_price",
					isTrans: false,
					sortable: false,
				});
			}
		},

		refreshTable() {
			this.$refs["listTable"].refreshData();
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
